import request from "@/utils/request";

export function submit(data) {
  return request({
    url: "/OvernightApplication/Submit",
    method: "post",
    data
  });
}
export function getBaseInfo(params) {
  return request({
    url: "/OvernightApplication/GetBaseInfo",
    method: "get",
    params
  });
}
export function getFactor(params) {
  return request({
    url: "/OvernightApplication/GetOvernightTimeRange",
    method: "get",
    params
  });
}
